import _asyncToGenerator from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _createClass from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/vercel/path0/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _regeneratorRuntime from "/vercel/path0/node_modules/@babel/runtime/regenerator/index.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { _registerComponent, registerVersion, getApp, _getProvider } from '@firebase/app';
import { FirebaseError, getModularInstance } from '@firebase/util';
import { Component } from '@firebase/component';
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var LONG_TYPE = 'type.googleapis.com/google.protobuf.Int64Value';
var UNSIGNED_LONG_TYPE = 'type.googleapis.com/google.protobuf.UInt64Value';

function mapValues( // { [k: string]: unknown } is no longer a wildcard assignment target after typescript 3.5
// eslint-disable-next-line @typescript-eslint/no-explicit-any
o, f) {
  var result = {};

  for (var key in o) {
    if (o.hasOwnProperty(key)) {
      result[key] = f(o[key]);
    }
  }

  return result;
}
/**
 * Takes data and encodes it in a JSON-friendly way, such that types such as
 * Date are preserved.
 * @internal
 * @param data - Data to encode.
 */


function encode(data) {
  if (data == null) {
    return null;
  }

  if (data instanceof Number) {
    data = data.valueOf();
  }

  if (typeof data === 'number' && isFinite(data)) {
    // Any number in JS is safe to put directly in JSON and parse as a double
    // without any loss of precision.
    return data;
  }

  if (data === true || data === false) {
    return data;
  }

  if (Object.prototype.toString.call(data) === '[object String]') {
    return data;
  }

  if (data instanceof Date) {
    return data.toISOString();
  }

  if (Array.isArray(data)) {
    return data.map(function (x) {
      return encode(x);
    });
  }

  if (typeof data === 'function' || typeof data === 'object') {
    return mapValues(data, function (x) {
      return encode(x);
    });
  } // If we got this far, the data is not encodable.


  throw new Error('Data cannot be encoded in JSON: ' + data);
}
/**
 * Takes data that's been encoded in a JSON-friendly form and returns a form
 * with richer datatypes, such as Dates, etc.
 * @internal
 * @param json - JSON to convert.
 */


function decode(json) {
  if (json == null) {
    return json;
  }

  if (json['@type']) {
    switch (json['@type']) {
      case LONG_TYPE: // Fall through and handle this the same as unsigned.

      case UNSIGNED_LONG_TYPE:
        {
          // Technically, this could work return a valid number for malformed
          // data if there was a number followed by garbage. But it's just not
          // worth all the extra code to detect that case.
          var value = Number(json['value']);

          if (isNaN(value)) {
            throw new Error('Data cannot be decoded from JSON: ' + json);
          }

          return value;
        }

      default:
        {
          throw new Error('Data cannot be decoded from JSON: ' + json);
        }
    }
  }

  if (Array.isArray(json)) {
    return json.map(function (x) {
      return decode(x);
    });
  }

  if (typeof json === 'function' || typeof json === 'object') {
    return mapValues(json, function (x) {
      return decode(x);
    });
  } // Anything else is safe to return.


  return json;
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Type constant for Firebase Functions.
 */


var FUNCTIONS_TYPE = 'functions';
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Standard error codes for different ways a request can fail, as defined by:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * This map is used primarily to convert from a backend error code string to
 * a client SDK error code string, and make sure it's in the supported set.
 */

var errorCodeMap = {
  OK: 'ok',
  CANCELLED: 'cancelled',
  UNKNOWN: 'unknown',
  INVALID_ARGUMENT: 'invalid-argument',
  DEADLINE_EXCEEDED: 'deadline-exceeded',
  NOT_FOUND: 'not-found',
  ALREADY_EXISTS: 'already-exists',
  PERMISSION_DENIED: 'permission-denied',
  UNAUTHENTICATED: 'unauthenticated',
  RESOURCE_EXHAUSTED: 'resource-exhausted',
  FAILED_PRECONDITION: 'failed-precondition',
  ABORTED: 'aborted',
  OUT_OF_RANGE: 'out-of-range',
  UNIMPLEMENTED: 'unimplemented',
  INTERNAL: 'internal',
  UNAVAILABLE: 'unavailable',
  DATA_LOSS: 'data-loss'
};
/**
 * An explicit error that can be thrown from a handler to send an error to the
 * client that called the function.
 */

var FunctionsError = /*#__PURE__*/function (_FirebaseError) {
  _inherits(FunctionsError, _FirebaseError);

  var _super = _createSuper(FunctionsError);

  function FunctionsError(
  /**
   * A standard error code that will be returned to the client. This also
   * determines the HTTP status code of the response, as defined in code.proto.
   */
  code, message,
  /**
   * Extra data to be converted to JSON and included in the error response.
   */
  details) {
    var _this;

    _classCallCheck(this, FunctionsError);

    _this = _super.call(this, "".concat(FUNCTIONS_TYPE, "/").concat(code), message || '');
    _this.details = details;
    return _this;
  }

  return _createClass(FunctionsError);
}(FirebaseError);
/**
 * Takes an HTTP status code and returns the corresponding ErrorCode.
 * This is the standard HTTP status code -> error mapping defined in:
 * https://github.com/googleapis/googleapis/blob/master/google/rpc/code.proto
 *
 * @param status An HTTP status code.
 * @return The corresponding ErrorCode, or ErrorCode.UNKNOWN if none.
 */


function codeForHTTPStatus(status) {
  // Make sure any successful status is OK.
  if (status >= 200 && status < 300) {
    return 'ok';
  }

  switch (status) {
    case 0:
      // This can happen if the server returns 500.
      return 'internal';

    case 400:
      return 'invalid-argument';

    case 401:
      return 'unauthenticated';

    case 403:
      return 'permission-denied';

    case 404:
      return 'not-found';

    case 409:
      return 'aborted';

    case 429:
      return 'resource-exhausted';

    case 499:
      return 'cancelled';

    case 500:
      return 'internal';

    case 501:
      return 'unimplemented';

    case 503:
      return 'unavailable';

    case 504:
      return 'deadline-exceeded';
  }

  return 'unknown';
}
/**
 * Takes an HTTP response and returns the corresponding Error, if any.
 */


function _errorForResponse(status, bodyJSON) {
  var code = codeForHTTPStatus(status); // Start with reasonable defaults from the status code.

  var description = code;
  var details = undefined; // Then look through the body for explicit details.

  try {
    var errorJSON = bodyJSON && bodyJSON.error;

    if (errorJSON) {
      var _status = errorJSON.status;

      if (typeof _status === 'string') {
        if (!errorCodeMap[_status]) {
          // They must've included an unknown error code in the body.
          return new FunctionsError('internal', 'internal');
        }

        code = errorCodeMap[_status]; // TODO(klimt): Add better default descriptions for error enums.
        // The default description needs to be updated for the new code.

        description = _status;
      }

      var message = errorJSON.message;

      if (typeof message === 'string') {
        description = message;
      }

      details = errorJSON.details;

      if (details !== undefined) {
        details = decode(details);
      }
    }
  } catch (e) {// If we couldn't parse explicit error data, that's fine.
  }

  if (code === 'ok') {
    // Technically, there's an edge case where a developer could explicitly
    // return an error code of OK, and we will treat it as success, but that
    // seems reasonable.
    return null;
  }

  return new FunctionsError(code, description, details);
}
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Helper class to get metadata that should be included with a function call.
 * @internal
 */


var ContextProvider = /*#__PURE__*/function () {
  function ContextProvider(authProvider, messagingProvider, appCheckProvider) {
    var _this2 = this;

    _classCallCheck(this, ContextProvider);

    this.auth = null;
    this.messaging = null;
    this.appCheck = null;
    this.auth = authProvider.getImmediate({
      optional: true
    });
    this.messaging = messagingProvider.getImmediate({
      optional: true
    });

    if (!this.auth) {
      authProvider.get().then(function (auth) {
        return _this2.auth = auth;
      }, function () {
        /* get() never rejects */
      });
    }

    if (!this.messaging) {
      messagingProvider.get().then(function (messaging) {
        return _this2.messaging = messaging;
      }, function () {
        /* get() never rejects */
      });
    }

    if (!this.appCheck) {
      appCheckProvider.get().then(function (appCheck) {
        return _this2.appCheck = appCheck;
      }, function () {
        /* get() never rejects */
      });
    }
  }

  _createClass(ContextProvider, [{
    key: "getAuthToken",
    value: function () {
      var _getAuthToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var token;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (this.auth) {
                  _context.next = 2;
                  break;
                }

                return _context.abrupt("return", undefined);

              case 2:
                _context.prev = 2;
                _context.next = 5;
                return this.auth.getToken();

              case 5:
                token = _context.sent;
                return _context.abrupt("return", token === null || token === void 0 ? void 0 : token.accessToken);

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](2);
                return _context.abrupt("return", undefined);

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[2, 9]]);
      }));

      function getAuthToken() {
        return _getAuthToken.apply(this, arguments);
      }

      return getAuthToken;
    }()
  }, {
    key: "getMessagingToken",
    value: function () {
      var _getMessagingToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(!this.messaging || !('Notification' in self) || Notification.permission !== 'granted')) {
                  _context2.next = 2;
                  break;
                }

                return _context2.abrupt("return", undefined);

              case 2:
                _context2.prev = 2;
                _context2.next = 5;
                return this.messaging.getToken();

              case 5:
                return _context2.abrupt("return", _context2.sent);

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](2);
                return _context2.abrupt("return", undefined);

              case 11:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[2, 8]]);
      }));

      function getMessagingToken() {
        return _getMessagingToken.apply(this, arguments);
      }

      return getMessagingToken;
    }()
  }, {
    key: "getAppCheckToken",
    value: function () {
      var _getAppCheckToken = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var result;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (!this.appCheck) {
                  _context3.next = 7;
                  break;
                }

                _context3.next = 3;
                return this.appCheck.getToken();

              case 3:
                result = _context3.sent;

                if (!result.error) {
                  _context3.next = 6;
                  break;
                }

                return _context3.abrupt("return", null);

              case 6:
                return _context3.abrupt("return", result.token);

              case 7:
                return _context3.abrupt("return", null);

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getAppCheckToken() {
        return _getAppCheckToken.apply(this, arguments);
      }

      return getAppCheckToken;
    }()
  }, {
    key: "getContext",
    value: function () {
      var _getContext = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var authToken, messagingToken, appCheckToken;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.getAuthToken();

              case 2:
                authToken = _context4.sent;
                _context4.next = 5;
                return this.getMessagingToken();

              case 5:
                messagingToken = _context4.sent;
                _context4.next = 8;
                return this.getAppCheckToken();

              case 8:
                appCheckToken = _context4.sent;
                return _context4.abrupt("return", {
                  authToken: authToken,
                  messagingToken: messagingToken,
                  appCheckToken: appCheckToken
                });

              case 10:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function getContext() {
        return _getContext.apply(this, arguments);
      }

      return getContext;
    }()
  }]);

  return ContextProvider;
}();
/**
 * @license
 * Copyright 2017 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


var DEFAULT_REGION = 'us-central1';
/**
 * Returns a Promise that will be rejected after the given duration.
 * The error will be of type FunctionsError.
 *
 * @param millis Number of milliseconds to wait before rejecting.
 */

function failAfter(millis) {
  // Node timers and browser timers are fundamentally incompatible, but we
  // don't care about the value here
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var timer = null;
  return {
    promise: new Promise(function (_, reject) {
      timer = setTimeout(function () {
        reject(new FunctionsError('deadline-exceeded', 'deadline-exceeded'));
      }, millis);
    }),
    cancel: function cancel() {
      if (timer) {
        clearTimeout(timer);
      }
    }
  };
}
/**
 * The main class for the Firebase Functions SDK.
 * @internal
 */


var FunctionsService = /*#__PURE__*/function () {
  /**
   * Creates a new Functions service for the given app.
   * @param app - The FirebaseApp to use.
   */
  function FunctionsService(app, authProvider, messagingProvider, appCheckProvider) {
    var _this3 = this;

    var regionOrCustomDomain = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : DEFAULT_REGION;
    var fetchImpl = arguments.length > 5 ? arguments[5] : undefined;

    _classCallCheck(this, FunctionsService);

    this.app = app;
    this.fetchImpl = fetchImpl;
    this.emulatorOrigin = null;
    this.contextProvider = new ContextProvider(authProvider, messagingProvider, appCheckProvider); // Cancels all ongoing requests when resolved.

    this.cancelAllRequests = new Promise(function (resolve) {
      _this3.deleteService = function () {
        return Promise.resolve(resolve());
      };
    }); // Resolve the region or custom domain overload by attempting to parse it.

    try {
      var url = new URL(regionOrCustomDomain);
      this.customDomain = url.origin;
      this.region = DEFAULT_REGION;
    } catch (e) {
      this.customDomain = null;
      this.region = regionOrCustomDomain;
    }
  }

  _createClass(FunctionsService, [{
    key: "_delete",
    value: function _delete() {
      return this.deleteService();
    }
    /**
     * Returns the URL for a callable with the given name.
     * @param name - The name of the callable.
     * @internal
     */

  }, {
    key: "_url",
    value: function _url(name) {
      var projectId = this.app.options.projectId;

      if (this.emulatorOrigin !== null) {
        var origin = this.emulatorOrigin;
        return "".concat(origin, "/").concat(projectId, "/").concat(this.region, "/").concat(name);
      }

      if (this.customDomain !== null) {
        return "".concat(this.customDomain, "/").concat(name);
      }

      return "https://".concat(this.region, "-").concat(projectId, ".cloudfunctions.net/").concat(name);
    }
  }]);

  return FunctionsService;
}();
/**
 * Modify this instance to communicate with the Cloud Functions emulator.
 *
 * Note: this must be called before this instance has been used to do any operations.
 *
 * @param host The emulator host (ex: localhost)
 * @param port The emulator port (ex: 5001)
 * @public
 */


function connectFunctionsEmulator$1(functionsInstance, host, port) {
  functionsInstance.emulatorOrigin = "http://".concat(host, ":").concat(port);
}
/**
 * Returns a reference to the callable https trigger with the given name.
 * @param name - The name of the trigger.
 * @public
 */


function httpsCallable$1(functionsInstance, name, options) {
  return function (data) {
    return call(functionsInstance, name, data, options || {});
  };
}
/**
 * Returns a reference to the callable https trigger with the given url.
 * @param url - The url of the trigger.
 * @public
 */


function httpsCallableFromURL$1(functionsInstance, url, options) {
  return function (data) {
    return callAtURL(functionsInstance, url, data, options || {});
  };
}
/**
 * Does an HTTP POST and returns the completed response.
 * @param url The url to post to.
 * @param body The JSON body of the post.
 * @param headers The HTTP headers to include in the request.
 * @return A Promise that will succeed when the request finishes.
 */


function postJSON(_x, _x2, _x3, _x4) {
  return _postJSON.apply(this, arguments);
}
/**
 * Calls a callable function asynchronously and returns the result.
 * @param name The name of the callable trigger.
 * @param data The data to pass as params to the function.s
 */


function _postJSON() {
  _postJSON = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(url, body, headers, fetchImpl) {
    var response, json;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            headers['Content-Type'] = 'application/json';
            _context5.prev = 1;
            _context5.next = 4;
            return fetchImpl(url, {
              method: 'POST',
              body: JSON.stringify(body),
              headers: headers
            });

          case 4:
            response = _context5.sent;
            _context5.next = 10;
            break;

          case 7:
            _context5.prev = 7;
            _context5.t0 = _context5["catch"](1);
            return _context5.abrupt("return", {
              status: 0,
              json: null
            });

          case 10:
            json = null;
            _context5.prev = 11;
            _context5.next = 14;
            return response.json();

          case 14:
            json = _context5.sent;
            _context5.next = 19;
            break;

          case 17:
            _context5.prev = 17;
            _context5.t1 = _context5["catch"](11);

          case 19:
            return _context5.abrupt("return", {
              status: response.status,
              json: json
            });

          case 20:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[1, 7], [11, 17]]);
  }));
  return _postJSON.apply(this, arguments);
}

function call(functionsInstance, name, data, options) {
  var url = functionsInstance._url(name);

  return callAtURL(functionsInstance, url, data, options);
}
/**
 * Calls a callable function asynchronously and returns the result.
 * @param url The url of the callable trigger.
 * @param data The data to pass as params to the function.s
 */


function callAtURL(_x5, _x6, _x7, _x8) {
  return _callAtURL.apply(this, arguments);
}

function _callAtURL() {
  _callAtURL = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(functionsInstance, url, data, options) {
    var body, headers, context, timeout, failAfterHandle, response, error, responseData, decodedData;
    return _regeneratorRuntime.wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            // Encode any special types, such as dates, in the input data.
            data = encode(data);
            body = {
              data: data
            }; // Add a header for the authToken.

            headers = {};
            _context6.next = 5;
            return functionsInstance.contextProvider.getContext();

          case 5:
            context = _context6.sent;

            if (context.authToken) {
              headers['Authorization'] = 'Bearer ' + context.authToken;
            }

            if (context.messagingToken) {
              headers['Firebase-Instance-ID-Token'] = context.messagingToken;
            }

            if (context.appCheckToken !== null) {
              headers['X-Firebase-AppCheck'] = context.appCheckToken;
            } // Default timeout to 70s, but let the options override it.


            timeout = options.timeout || 70000;
            failAfterHandle = failAfter(timeout);
            _context6.next = 13;
            return Promise.race([postJSON(url, body, headers, functionsInstance.fetchImpl), failAfterHandle.promise, functionsInstance.cancelAllRequests]);

          case 13:
            response = _context6.sent;
            // Always clear the failAfter timeout
            failAfterHandle.cancel(); // If service was deleted, interrupted response throws an error.

            if (response) {
              _context6.next = 17;
              break;
            }

            throw new FunctionsError('cancelled', 'Firebase Functions instance was deleted.');

          case 17:
            // Check for an error status, regardless of http status.
            error = _errorForResponse(response.status, response.json);

            if (!error) {
              _context6.next = 20;
              break;
            }

            throw error;

          case 20:
            if (response.json) {
              _context6.next = 22;
              break;
            }

            throw new FunctionsError('internal', 'Response is not valid JSON object.');

          case 22:
            responseData = response.json.data; // TODO(klimt): For right now, allow "result" instead of "data", for
            // backwards compatibility.

            if (typeof responseData === 'undefined') {
              responseData = response.json.result;
            }

            if (!(typeof responseData === 'undefined')) {
              _context6.next = 26;
              break;
            }

            throw new FunctionsError('internal', 'Response is missing data field.');

          case 26:
            // Decode any special types, such as dates, in the returned data.
            decodedData = decode(responseData);
            return _context6.abrupt("return", {
              data: decodedData
            });

          case 28:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _callAtURL.apply(this, arguments);
}

var name = "@firebase/functions";
var version = "0.8.2";
/**
 * @license
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var AUTH_INTERNAL_NAME = 'auth-internal';
var APP_CHECK_INTERNAL_NAME = 'app-check-internal';
var MESSAGING_INTERNAL_NAME = 'messaging-internal';

function registerFunctions(fetchImpl, variant) {
  var factory = function factory(container, _ref) {
    var regionOrCustomDomain = _ref.instanceIdentifier;
    // Dependencies
    var app = container.getProvider('app').getImmediate();
    var authProvider = container.getProvider(AUTH_INTERNAL_NAME);
    var messagingProvider = container.getProvider(MESSAGING_INTERNAL_NAME);
    var appCheckProvider = container.getProvider(APP_CHECK_INTERNAL_NAME); // eslint-disable-next-line @typescript-eslint/no-explicit-any

    return new FunctionsService(app, authProvider, messagingProvider, appCheckProvider, regionOrCustomDomain, fetchImpl);
  };

  _registerComponent(new Component(FUNCTIONS_TYPE, factory, "PUBLIC"
  /* PUBLIC */
  ).setMultipleInstances(true));

  registerVersion(name, version, variant); // BUILD_TARGET will be replaced by values like esm5, esm2017, cjs5, etc during the compilation

  registerVersion(name, version, 'esm2017');
}
/**
 * @license
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Returns a {@link Functions} instance for the given app.
 * @param app - The {@link @firebase/app#FirebaseApp} to use.
 * @param regionOrCustomDomain - one of:
 *   a) The region the callable functions are located in (ex: us-central1)
 *   b) A custom domain hosting the callable functions (ex: https://mydomain.com)
 * @public
 */


function getFunctions() {
  var app = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getApp();
  var regionOrCustomDomain = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_REGION;

  // Dependencies
  var functionsProvider = _getProvider(getModularInstance(app), FUNCTIONS_TYPE);

  var functionsInstance = functionsProvider.getImmediate({
    identifier: regionOrCustomDomain
  });
  return functionsInstance;
}
/**
 * Modify this instance to communicate with the Cloud Functions emulator.
 *
 * Note: this must be called before this instance has been used to do any operations.
 *
 * @param host - The emulator host (ex: localhost)
 * @param port - The emulator port (ex: 5001)
 * @public
 */


function connectFunctionsEmulator(functionsInstance, host, port) {
  connectFunctionsEmulator$1(getModularInstance(functionsInstance), host, port);
}
/**
 * Returns a reference to the callable HTTPS trigger with the given name.
 * @param name - The name of the trigger.
 * @public
 */


function httpsCallable(functionsInstance, name, options) {
  return httpsCallable$1(getModularInstance(functionsInstance), name, options);
}
/**
 * Returns a reference to the callable HTTPS trigger with the specified url.
 * @param url - The url of the trigger.
 * @public
 */


function httpsCallableFromURL(functionsInstance, url, options) {
  return httpsCallableFromURL$1(getModularInstance(functionsInstance), url, options);
}
/**
 * Cloud Functions for Firebase
 *
 * @packageDocumentation
 */


registerFunctions(fetch.bind(self));
export { connectFunctionsEmulator, getFunctions, httpsCallable, httpsCallableFromURL };